var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 268,
    viewBox: "0 0 268 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 268,
    height: 268,
    rx: 134,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.53 29.5V109.13",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67 109.13H144.39",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.96 51.22L166.1 36.74",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.48 87.41C86.48 95.4 95.53 98.27 100.96 98.27C106.39 98.27 115.44 95.41 115.44 87.41L100.96 51.22L86.48 87.41Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63 72.93C151.63 80.92 160.68 83.79 166.11 83.79C171.54 83.79 180.59 80.93 180.59 72.93L166.11 36.74L151.63 72.93Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9 158.73L98.78 181.84",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.96 146.66L139.09 141.53C145.27 135.35 155.31 135.35 161.51 141.53L187.07 167.11C193.27 173.29 193.27 183.33 187.07 189.53L146.76 229.84",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21 184.4L104.24 200.37C100.93 203.68 95.5601 203.68 92.2401 200.37C88.9301 197.06 88.9301 191.69 92.2401 188.37L112.67 167.94",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.21 196.4L116.24 212.37C112.93 215.68 107.56 215.68 104.24 212.37C100.93 209.06 100.93 203.69 104.24 200.37L120.21 184.4",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.2 208.39L128.23 224.36C124.92 227.67 119.55 227.67 116.23 224.36C112.92 221.05 112.92 215.68 116.23 212.36L132.2 196.39",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.66 215.93L140.23 236.36C136.92 239.67 131.55 239.67 128.23 236.36C124.92 233.05 124.92 227.68 128.23 224.36L144.2 208.39",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.94 184.4C74.05 178.49 75.07 171.15 79.98 166.24L105.55 140.67C111.74 134.48 121.78 134.48 127.96 140.67L147.74 160.45C151.07 163.78 151.07 169.18 147.74 172.51C144.41 175.84 139.01 175.84 135.68 172.51L121.89 158.72",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.503 158.854L170.35 124.701L157.516 137.535L191.669 171.688L204.503 158.854Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6623 123.299L62.509 157.453L75.343 170.287L109.496 136.133L96.6623 123.299Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89 140.56C171.812 140.56 173.37 139.002 173.37 137.08C173.37 135.158 171.812 133.6 169.89 133.6C167.968 133.6 166.41 135.158 166.41 137.08C166.41 139.002 167.968 140.56 169.89 140.56Z",
    fill: "#39BBD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.27 140.09C98.192 140.09 99.75 138.532 99.75 136.61C99.75 134.688 98.192 133.13 96.27 133.13C94.3481 133.13 92.79 134.688 92.79 136.61C92.79 138.532 94.3481 140.09 96.27 140.09Z",
    fill: "#39BBD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 214.34,
    fill: "white",
    transform: "translate(60 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.9d490fbd689a246db77e5bc8784e57d7.svg";
export { ForwardRef as ReactComponent };